import { Box } from "@mui/system";
import { useEffect, useState } from "react";
import Title from "../Dashboard/Title";
import PropTypes from "prop-types";
import Typography from "@mui/material/Typography";
import GlobalStyles from "../../assets/globalStyle";
import OnlineAdmission from "./onlineAdmission/OnlineAdmission";
import { Calender } from "./SchoolAdmCalender/Calender";
import { TimeTable } from "./TimeTable";
import EntranceExam from "./EntranceExam/Index";
import Vendor from "./VendorInventory/Vendor";
import { Payment } from "./Payment/payment";
import { useNavigate, useSearchParams } from "react-router-dom";

const QAFirst = () => {
  const [mainTab, setMainTab] = useState(0);
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const tabFromUrl = Number(searchParams.get("tab"));
    if (!isNaN(tabFromUrl)) {
      setMainTab(tabFromUrl);
    }
  }, [searchParams]);

  const handleTabChange = (index) => {
    setMainTab(index);
    setSearchParams({ tab: index });
  };

  return (
    <>
      <GlobalStyles />
      <Box>
        <Title title="Quality Assurance" />
      </Box>
      <Box>
        <div className="flex justify-between my-5 cursor-pointer border-b gap-3">
          {[
            "Online Admission",
            "School Academic Calendar",
            "Books Vendor Inventory",
            "Entrance Examination",
            "Class Timetable",
            "Submitted Payments",
          ].map((label, index) => (
            <span
              key={index}
              className={
                mainTab === index
                  ? "text-[#691e78] border-b-2 border-b-[#691e78] text-[19px]"
                  : "text-gray-300 text-[15px]"
              }
              onClick={() => handleTabChange(index)}
            >
              {label}
            </span>
          ))}
        </div>
      </Box>

      <Box>
        {mainTab === 0 && <OnlineAdmission />}
        {mainTab === 1 && <Calender />}
        {mainTab === 2 && <Vendor />}
        {mainTab === 3 && <EntranceExam />}
        {mainTab === 4 && <TimeTable />}
        {mainTab === 5 && <Payment />}
      </Box>
    </>
  );
};

export default QAFirst;

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ mt: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};
